import { render } from "./api-contact.vue?vue&type=template&id=176faedc&scoped=true&ts=true"
import script from "./api-contact.vue?vue&type=script&lang=ts"
export * from "./api-contact.vue?vue&type=script&lang=ts"

import "./api-contact.vue?vue&type=style&index=0&id=176faedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176faedc"]])

export default __exports__